"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetMap = void 0;
var typescript_collections_1 = require("typescript-collections");
var Utils_1 = require("../Utils");
var AssetMap = /** @class */ (function () {
    function AssetMap() {
    }
    /**
     * Add a group of assets under the id passed in.
     * @param pGroupId The id of the asset group - usually the id of the state.
     * @param pAssets A list of asset names.
     */
    AssetMap.addAssetGroup = function (pGroupId, pAssets) {
        this._map.setValue(pGroupId, pAssets);
    };
    /**
     * Retrieves the assets in the specified group.
     * @param pGroupId The id of the asset group.
     * @returns The assets or and empty string array if map is empty or group not found.
     */
    AssetMap.getAssetGroup = function (pGroupId) {
        if (this._map.size() === 0) {
            this.logE("Asset map is empty. Call addAssetGroup first. Returning empty array.");
            return new Array();
        }
        else {
            var assets = this._map.getValue(pGroupId);
            if (assets === undefined) {
                this.logE("%c%s%c asset group has not been added to the map. Call addAssetGroup first. Returning " +
                    "empty array.", Utils_1.LogUtils.STYLE_RED_BOLD, pGroupId, Utils_1.LogUtils.STYLE_BLACK);
                return new Array();
            }
            else {
                return assets;
            }
        }
    };
    /**
     * Logs a message with class name and colour coding if debug flag is true.
     * @param pText The message to print.
     * @param [pParams] Optional data to be included in the message.
     * @todo Relish GM => Decide if this should live in its own class, be in an interface or within each manager.
     */
    AssetMap.log = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        if (this._debug) {
            Utils_1.LogUtils.log.apply(Utils_1.LogUtils, __spreadArrays([pText, { className: "AssetMap", color: "green" }], pParams));
        }
    };
    /**
     * Logs a warning message with class name and colour coding if debug flag is true.
     * @param pText The message to print.
     * @param [pParams] Optional data to be included in the message.
     * @todo Relish GM => Decide if this should live in its own class, be in an interface or within each manager.
     */
    AssetMap.logW = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        if (this._debug) {
            Utils_1.LogUtils.logWarning.apply(Utils_1.LogUtils, __spreadArrays([pText, { className: "AssetMap", color: "green" }], pParams));
        }
    };
    /**
     * Logs an error message with class name and colour coding.
     * @param pText The message to print.
     * @param [pParams] Optional data to be included in the message.
     * @todo Relish GM => Decide if this should live in its own class, be in an interface or within each manager.
     */
    AssetMap.logE = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        Utils_1.LogUtils.logError.apply(Utils_1.LogUtils, __spreadArrays([pText, { className: "AssetMap", color: "green" }], pParams));
    };
    AssetMap._map = new typescript_collections_1.Dictionary();
    AssetMap._debug = false;
    return AssetMap;
}());
exports.AssetMap = AssetMap;
//# sourceMappingURL=AssetMap.js.map